const ACCORDEON = {
    nodes: document.querySelectorAll('.accordeon__detail'),
    onReady: function() {
        ACCORDEON.nodes.forEach(node => {
            node.addEventListener('click', event => {
                event.preventDefault();
                ACCORDEON.onClick({element: node});
            });
        });
    },
    onClick: function({element}) {
        ACCORDEON.nodes.forEach(node => {
            node.style.overflow = 'hidden';
            (element !== node) && (ACCORDEON.shrink({element: node}));
        });
        (element.open) ? ACCORDEON.shrink({element: element}) : ACCORDEON.open({element: element});
    },
    open: function({element}) {
        element.style.height = `${element.offsetHeight}px`;
        element.open = true;
        window.requestAnimationFrame(() => ACCORDEON.expand({element: element}));
    },
    expand: function({element}) {
        const content     = element.querySelector('.accordeon__content');
        const startHeight = `${element.offsetHeight}px`;
        const endHeight   = `${element.offsetHeight + content.offsetHeight}px`;
        
        (element.animation) && element.animation.cancel();
        
        element.animation = element.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 500,
            easing: 'ease-out'
        });
        element.animation.onfinish = () => {
            ACCORDEON.onAnimationFinish({element: element, open: true});
            let offset  = document.getElementById('header').clientHeight;
            let scrollY = element.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo(0, scrollY);
        }
    },
    shrink: function({element}) {
        if (element.open === false) return;
        const content     = element.querySelector('.accordeon__content');
        const startHeight = `${element.offsetHeight}px`;
        const endHeight   = `${element.offsetHeight - content.offsetHeight - 24}px`;
        
        (element.animation) && element.animation.cancel();
        
        element.animation = element.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 500,
            easing: 'ease-out'
        });
        element.animation.onfinish = () => ACCORDEON.onAnimationFinish({element: element, open: false});
    },
    onAnimationFinish: function({element, open}) {
        (open) ? element.classList.add('active') : element.classList.remove('active'); // for tracking purposes
        element.open = open;
        element.style.height = '';
        element.style.overflow = '';
    }
}